import React from 'react';
import ReactDOM from 'react-dom';

type Props = {
  children: React.ReactNode;
};

const HEADER_ID = '#newron-header-content';

function ClientHeader({ children }: Props): React.ReactPortal | null {
  const [isInDocument, setIsInDocument] = React.useState<boolean>(false);
  const timer = React.useRef<ReturnType<typeof setTimeout>>(null);

  React.useEffect(() => {
    const checkInDocument = () => {
      const el = document.querySelector(HEADER_ID);
      if (!el) {
        if (timer.current) {
          clearTimeout(timer.current);
        }
        timer.current = setTimeout(checkInDocument, 50);
        setIsInDocument(false);
        return;
      } else {
        setIsInDocument(true);
      }
    };
    checkInDocument();
  }, []);

  if (!isInDocument) {
    return null;
  }

  const el = document.querySelector(HEADER_ID);

  if (!el) {
    console.warn('Newron header could not be located in the HTML');
    return null;
  }

  return ReactDOM.createPortal(children, el);
}

export { ClientHeader };
